<div
  class="sticky h-0 z-10 transition-all"
  [ngClass]="{
    'lg:top-10 top-[117px]': isPromoBannerVisible$ | async,
    'lg:top-0 top-[59px]': (isPromoBannerVisible$ | async) === false,
    'md:opacity-0': hideMenu(),
    'md:opacity-100': hideMenu() === false,
  }"
>
  <div class="relative">
    <div
      class="absolute top-0 lg:top-24 max-md:mx-8 max-md:max-w-[calc(100vw-4rem)] md:mt-20 flex max-w flex-row md:flex-col max-md:overflow-x-auto bg-black max-md:rounded-b-xl md:rounded-r-2xl md:w-fit p-6 md:p-4 md:pr-6 gap-6"
    >
      @for (
        item of timelineData.timelineItems;
        track trackTimelineItem(index, item);
        let index = $index
      ) {
        <div class="relative">
          <a
            class="text-xs tracking-wider no-underline whitespace-nowrap md:whitespace-normal"
            [ngClass]="{ 'ss-active-link': index === currentSection() }"
            [routerLink]="['./']"
            [fragment]="item.id.toString()"
            (click)="setCurrentSection(index)"
          >
            {{ item.year }}
          </a>
          @if (index === currentSection()) {
            <div
              class="w-[1px] md:w-4 h-3 md:h-[1px] bg-white absolute max-md:-bottom-6 max-md:left-1/2 md:-right-6 md:top-1/2"
            ></div>
          }
        </div>
      }
    </div>
  </div>
</div>
@for (
  item of timelineData.timelineItems;
  track trackTimelineItem($index, item);
  let first = $first
) {
  <div
    class="flex content-center px-8 md:px-16 lg:px-24 xl:px-32 [&>*]:normal-case scroll-pt"
    [ngClass]="{ 'pt-28 md:pt-8': first }"
    [innerHTML]="item.sectionHeader"
    [id]="item.id"
    #sectionHeaders
    [ssDirectus]="{
      collection: 'timelineItems',
      item: item.id,
      fields: ['sectionHeader'],
    }"
  ></div>
  <ss-www-building-block-outlet
    [blocks]="item.timelineBlocks"
    [setLastItemFooterBackground]="lastBlock"
  ></ss-www-building-block-outlet>
}
